export const ACT = {
  组织Onwer: 1,
  超级管理: 2,
  组织编辑: 3,
  组织加人: 4,
  Group加人: 5,
  Group查询: 6,
  组织查询: 7,
  文档编辑: 8,
  文档查看: 9,
  大纲查看: 10,
  大纲编辑: 11,
  文档管理: 12,
  大纲管理: 13,
  空权限: 14,
  失效: 15,
  不可见: 16,
  修改状态: 17,
  记录修改文档: 0,
  记录创建节点: 1,
  记录修改属性: 2,
  记录修改标题: 3,
  记录移动节点: 4,
  记录删除节点: 5,
  记录修改颜色: 7,
  记录修改状态: 8,
  记录移到回收站: 9,
  记录从回收站恢复: 10,
  记录移动端修改: 11,
  记录移动端创建: 12
};

// 节点权限类型
export const NODE_PERMISSION = {
  管理: 0,
  编辑: 1,
  只读: 2,
  不可见: 3,
  可转换: 4
};

// 节点提权类型
export const ACL_PERMISSION = {
  管理: 3,
  编辑: 4,
  只读: 5,
  经办: 6
};

// 节点权限对应act
export const NODE_ACL_MAP = {
  [NODE_PERMISSION.管理]: [ACT.文档编辑, ACT.大纲编辑, ACT.大纲管理, ACT.修改状态],
  [NODE_PERMISSION.编辑]: [ACT.文档编辑, ACT.大纲编辑, ACT.修改状态],
  [NODE_PERMISSION.只读]: [ACT.文档查看, ACT.大纲查看],
  [NODE_PERMISSION.不可见]: [ACT.不可见],
  [NODE_PERMISSION.可转换]: [ACT.修改状态]
};
export const getAclKey = aclObj => {
  if (!aclObj) return null;
  const str = JSON.stringify(Object.keys(aclObj).map(Number));
  let resKey = null;
  Object.keys(NODE_ACL_MAP).forEach(key => {
    // @ts-ignore
    if (JSON.stringify(NODE_ACL_MAP[key]) === str) {
      resKey = key;
    }
  });
  return resKey;
};

// {key:0,value:管理}
export const PERMISSION_OPTION = Object.keys(NODE_PERMISSION).map(_value => {
  const value = _value;
  return {
    key: NODE_PERMISSION[value],
    value: value
  };
});
export const NODE_ACL_OPTION = Object.keys(ACL_PERMISSION).map(_value => {
  const value = _value;
  return {
    key: ACL_PERMISSION[value],
    value: value
  };
});
export const SYSTEM_FIELD_AUTH = {
  _sys_hide: {
    name: '仅管理员可见'
  },
  _sys_protect: {
    name: '禁止删除'
  },
  _sys_readonly: {
    name: '禁止编辑(只读)'
  },
  _sys_mute: {
    name: '禁止聊天'
  },
  _sys_child_limit: {
    name: '子节点最深层级'
  },
  _sys_group_acl: {
    name: '组权限'
  },
  _sys_c_group_acl: {
    name: '组权限(子节点)'
  },
  _sys_user_acl: {
    name: '用户权限'
  },
  _sys_c_user_acl: {
    name: '用户权限(子节点)'
  }
};
export const SYSTEM_FIELD = {
  _sys_subscriber: {
    name: '关注者'
  },
  _sys_creator: {
    name: '创建人'
  },
  _sys_createTime: {
    name: '创建时间'
  },
  _sys_updateTime: {
    name: '修改时间'
  },
  _sys_delete_time: {
    name: '删除时间'
  },
  _sys_delete_operator: {
    name: '操作人'
  },
  ...SYSTEM_FIELD_AUTH
};

/**
 * 空间权限
 */
export const ORG_ROLE = {
  /**
   * 空间owner
   */
  OWNER: 1,
  /**
   * 管理员
   */
  ADMIN: 3,
  /**
   * 编辑
   */
  EDIT: 4,
  /**
   * 只读
   */
  READONLY: 5,
  /**
   * 新增
   */
  ADDONLY: 7,
  /**
   * 外部成员
   */
  VISITOR: 8
};